import React from "react";
import { Form, Input, Button, message, Upload, Row, Col } from "antd";
import axios from "axios";
import { API_URL } from "../../config";
const EditDoctorProfile = ({ doctorDetails, onClose, onProfileUpdate }) => {
  const [form] = Form.useForm();
  const [uploading, setUploading] = React.useState(false);
  const apiEndpoint = `${API_URL}/doctor/${doctorDetails?.doctor_id}`;

  const handleFinish = async (values) => {
    try {
      const response = await axios.put(
        apiEndpoint,
        {
          ...values,
          firebase_id: doctorDetails?.firebase_id,
          doctor_id: doctorDetails?.doctor_id,
        },
        {
          headers: {
            "Content-Type": "application/json",
          },
        },
      );

      if (response.status === 200) {
        message.success("Profile updated successfully");
        onProfileUpdate(response.data);
        onClose();
      } else {
        message.error("Failed to update profile");
      }
    } catch (error) {
      console.error("Error updating doctor profile:", error);
      message.error("An error occurred while updating the profile");
    }
  };

  const handleUpload = async ({ file }) => {
    const formData = new FormData();
    formData.append("firebase_id", doctorDetails?.firebase_id);
    formData.append("file", file);

    setUploading(true);

    try {
      const response = await axios.post(
        `${API_URL}/user/upload-profile-picture`,
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        },
      );
      if (response.status === 200) {
        message.success("Profile picture uploaded successfully");
      } else {
        message.error("Failed to upload profile picture");
      }
    } catch (error) {
      console.error("Error uploading profile picture:", error);
      message.error("An error occurred while uploading the profile picture");
    } finally {
      setUploading(false);
    }
  };

  return (
    <Form
      form={form}
      layout="vertical"
      initialValues={{
        salutation: doctorDetails?.salutation,
        first_name: doctorDetails?.first_name,
        last_name: doctorDetails?.last_name,
        phone_number: doctorDetails?.phone_number,
        email_address: doctorDetails?.email_address,
        date_of_birth: doctorDetails?.date_of_birth,
        gender: doctorDetails?.gender,
        clinic: doctorDetails?.clinic,
        professional_profile: doctorDetails?.professional_profile,
        medical_registration: doctorDetails?.medical_registration,
        specialties: doctorDetails?.specialties,
        qualifications: doctorDetails?.qualifications,
      }}
      onFinish={handleFinish}
    >
      <Row gutter={16}>
        <Col span={8}>
          {" "}
          <Form.Item
            name="salutation"
            label="Salutation"
            rules={[
              { required: true, message: "Please enter the salutation!" },
            ]}
          >
            <Input />
          </Form.Item>
        </Col>
        <Col span={8}>
          <Form.Item
            name="first_name"
            label="First Name"
            rules={[
              { required: true, message: "Please enter the first name!" },
            ]}
          >
            <Input />
          </Form.Item>
        </Col>
        <Col span={8}>
          <Form.Item
            name="last_name"
            label="Last Name"
            rules={[{ required: true, message: "Please enter the last name!" }]}
          >
            <Input />
          </Form.Item>
        </Col>
      </Row>
      <Row>
        {" "}
        <Col span={10}>
          <Form.Item
            name="phone_number"
            label="Phone Number"
            rules={[
              { required: true, message: "Please enter the phone number!" },
            ]}
          >
            <Input />
          </Form.Item>
        </Col>
        <Col span={2}></Col>
        <Col span={12}>
          {" "}
          <Form.Item
            name="email_address"
            label="Email Address"
            rules={[
              { required: true, message: "Please enter the email address!" },
            ]}
          >
            <Input
              disabled
              style={{
                backgroundColor: "#e8e8e8",
                color: "black",
                cursor: "not-allowed",
              }}
            />
          </Form.Item>
        </Col>{" "}
      </Row>

      <Row gutter={16}>
        <Col span={8}>
          {" "}
          <Form.Item
            name="gender"
            label="Gender"
            rules={[{ required: true, message: "Please enter the gender!" }]}
          >
            <Input />
          </Form.Item>
        </Col>
        <Col span={8}>
          <Form.Item
            name="date_of_birth"
            label="Date of Birth"
            rules={[
              { required: true, message: "Please enter the date of birth!" },
            ]}
          >
            <Input type="date" />
          </Form.Item>
        </Col>
        <Col span={8}>
          {" "}
          <Form.Item
            name="clinic"
            label="Clinic"
            rules={[{ required: true, message: "Please enter the clinic!" }]}
          >
            <Input />
          </Form.Item>
        </Col>
      </Row>

      <Row>
        <Col span={10}>
          {" "}
          <Form.Item name="professional_profile" label="Professional Profile">
            <Input.TextArea />
          </Form.Item>{" "}
        </Col>
        <Col span={2}></Col>
        <Col span={12}>
          {" "}
          <Form.Item name="medical_registration" label="Medical Registration">
            <Input.TextArea />
          </Form.Item>
        </Col>
      </Row>
      <Row>
        <Col span={10}>
          {" "}
          <Form.Item name="specialties" label="Specialties">
            <Input.TextArea />
          </Form.Item>{" "}
        </Col>
        <Col span={2}></Col>
        <Col span={12}>
          {" "}
          <Form.Item name="qualifications" label="Qualifications">
            <Input.TextArea />
          </Form.Item>
        </Col>
      </Row>

      <Row>
        <Col span={10}>
          <Form.Item
            label="Upload Profile Picture"
            extra="Upload a PNG, JPG, or JPEG image for your profile picture."
          >
            <Upload
              showUploadList={false}
              customRequest={handleUpload}
              accept=".png, .jpg, .jpeg"
            >
              <Button loading={uploading} type="default">
                {uploading ? "Uploading..." : "Upload Profile Picture"}
              </Button>
            </Upload>
          </Form.Item>
        </Col>
      </Row>

      <Form.Item>
        <Row gutter={10}>
          <Col span={20}></Col>

          <Col>
            <Button type="primary" danger onClick={onClose}>
              Cancel
            </Button>
          </Col>
          <Col>
            <Button type="primary" htmlType="submit">
              Save
            </Button>
          </Col>
        </Row>
      </Form.Item>
    </Form>
  );
};

export default EditDoctorProfile;
